(function ($) {
  $(document).ready(function () {
    $(".loader-wrapper").fadeOut();
    $(window).trigger("scroll"); // Trigger a scroll event after the window loads.
  });
})(jQuery);
